import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import BaseFormBlock from "../BaseFormBlock";
import PropTypes from "prop-types";
import AnswerTitle from "../AnswerTitle";
import BaseIcon from "../../../../components/BaseIcon";
import "./style.scss";

export default function DropDownAnswer({
  title,
  name,
  onChange,
  value,
  number,
}) {
  DropDownAnswer.propTypes = {
    number: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
  };

  const numRef = useRef();
  const { t } = useTranslation();

  const [valueNumber, setValueNumber] = useState("");
  const [valuePeriod, setValuePeriod] = useState("week");

  const onValueChange = (event) => {
    if (event.target.type === "text") {
      /* empty */
      if (
        +event.target.value > 100 ||
        +event.target.value < 0 ||
        Number.isNaN(+event.target.value)
      )
        return;
      setValueNumber(event.target.value);
    }
    if (event.target.type === "select-one") {
      /* empty */
      setValuePeriod(event.target.value);
    }
  };
  const onStep = (typeStep) => {
    if (+valueNumber === 0 && typeStep === "-") return;
    setValueNumber((prevState) => {
      return typeStep === "+" ? +prevState + 1 : +prevState - 1;
    });
  };

  useEffect(() => {
    onChange({ target: { value: `${valueNumber}:${valuePeriod}`, name } });
  }, [name, valueNumber, valuePeriod]);

  useEffect(() => {
    if (value) {
      const parsedValue = value.split(":");
      setValueNumber(parsedValue[0].length ? +parsedValue[0] : "");
      setValuePeriod(parsedValue[1]);
    }
  }, [value]);

  return (
    <BaseFormBlock>
      <div className="dropdown-answer">
        <AnswerTitle title={title} number={number} />
        <div className="dropdown-answer__input-wrapper">
          <div className="dropdown-answer__gradient_wrapper">
            <input
              ref={numRef}
              className="dropdown-answer__number"
              name={name}
              placeholder="0"
              type="text"
              value={valueNumber}
              onChange={(event) => onValueChange(event)}
            />
            <div className="dropdown-answer__number-arrows">
              <BaseIcon onClick={() => onStep("+")} name="top_triangle" />
              <BaseIcon onClick={() => onStep("-")} name="bottom_triangle" />
            </div>
          </div>
          <div className="dropdown-answer__gradient_wrapper">
            <div className="dropdown-answer__selcect-arrow">
              <BaseIcon name="bottom_triangle" />
            </div>
            <select
              className="dropdown-answer__select"
              onChange={(event) => onValueChange(event)}
              name={name}
              value={valuePeriod}
              placeholder={t("insight_questionnaire_form_page.myAnswer")}
            >
              <option value="week" defaultValue="week">
                {t("insight_questionnaire_form_page.inWeek")}
              </option>
              <option value="month">
                {t("insight_questionnaire_form_page.inMonth")}
              </option>
              <option value="year">
                {t("insight_questionnaire_form_page.inYear")}
              </option>
            </select>
          </div>
        </div>
      </div>
    </BaseFormBlock>
  );
}
